import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-391">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-392">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-393" />

          {/* Modal Content */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] overflow-hidden" data-id="element-394">
            {/* Header */}
            <div className="bg-[#1e3a5f] px-6 py-4 flex items-center justify-between" data-id="element-395">
              <h2 className="text-xl font-bold text-white" data-id="element-396">{title}</h2>
              <button onClick={onClose} className="text-white/70 hover:text-white transition-colors p-1 rounded-lg hover:bg-white/10" data-id="element-397">
                <X className="w-6 h-6" data-id="element-398" />
              </button>
            </div>

            {/* Scrollable Content */}
            <div className="p-6 md:p-8 overflow-y-auto max-h-[calc(85vh-72px)]" data-id="element-399">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}